import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import { initGA, trackPageview } from './utils/analytics';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Navigation from './components/Navigation';
import FloatingCart from './components/FloatingCart';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Blog from './pages/Blog';
import Forum from './pages/Forum';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import CheckoutPix from './pages/CheckoutPix';
import MinhasCompras from './pages/MinhasCompras';
import Profile from './pages/Profile';
import Atividades from './pages/Atividades';
import Sobre from './pages/Sobre';
import AdminBlog from './pages/AdminBlog';
import AdminTextos from './pages/AdminTextos';
import AdminVocabulario from './pages/AdminVocabulario';
import AdminUsers from './pages/AdminUsers';
import AdminDashboard from './pages/AdminDashboard';
import AdminNotificacoes from './pages/AdminNotificacoes';
import AdminAlunos from './pages/AdminAlunos';
import AdminDialogos from './pages/AdminDialogos';
import AdminPronuncia from './pages/AdminPronuncia';
import Dialogos from './pages/Dialogos';
import JogoPronuncia from './pages/JogoPronuncia';
import Pratica from './pages/Pratica';
import Vocabulario from './pages/Vocabulario';
import EspacoKids from './pages/EspacoKids';
import JogoPergunta from './pages/JogoPergunta';
import ColorGame from './pages/ColorGame';
import DicionarioFaminto from './pages/DicionarioFaminto';
import Verbos from './pages/Verbos';
import AdminVerbos from './pages/AdminVerbos';
import PhrasalVerbs from './pages/PhrasalVerbs';
import FalsosCongnatos from './pages/FalsosCongnatos';
import Idioms from './pages/Idioms';
import ConversaIA from './pages/ConversaIA';
import NotFound from './pages/NotFound';

function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    initGA();
  }, []);

  useEffect(() => {
    trackPageview(location.pathname + location.search);
  }, [location]);

  return null;
}

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <AnalyticsTracker />
        <Navigation />
        <div className="app-body">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/forum" element={<Forum />} />
            <Route path="/produtos" element={<Products />} />
            <Route path="/produto/:id" element={<ProductDetail />} />
            <Route path="/carrinho" element={<Cart />} />
            <Route path="/checkout" element={<ProtectedRoute><Checkout /></ProtectedRoute>} />
            <Route path="/checkout/pix" element={<ProtectedRoute><CheckoutPix /></ProtectedRoute>} />
            <Route path="/minhas-compras" element={<MinhasCompras />} />
            <Route path="/atividades" element={<ProtectedRoute><Atividades /></ProtectedRoute>} />
            <Route path="/usuarios" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
            <Route path="/sobre" element={<Sobre />} />
            <Route path="/admin-dashboard"      element={<ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin-blog"           element={<ProtectedRoute adminOnly><AdminBlog /></ProtectedRoute>} />
            <Route path="/admin-textos"         element={<ProtectedRoute adminOnly><AdminTextos /></ProtectedRoute>} />
            <Route path="/admin-vocabulario"    element={<ProtectedRoute adminOnly><AdminVocabulario /></ProtectedRoute>} />
            <Route path="/admin-users"          element={<ProtectedRoute adminOnly><AdminUsers /></ProtectedRoute>} />
            <Route path="/admin-notificacoes"   element={<ProtectedRoute adminOnly><AdminNotificacoes /></ProtectedRoute>} />
            <Route path="/admin-alunos"         element={<ProtectedRoute adminOnly><AdminAlunos /></ProtectedRoute>} />
            <Route path="/admin-dialogos"       element={<ProtectedRoute adminOnly><AdminDialogos /></ProtectedRoute>} />
            <Route path="/admin-pronuncia"      element={<ProtectedRoute adminOnly><AdminPronuncia /></ProtectedRoute>} />
            <Route path="/dialogos"             element={<ProtectedRoute><Dialogos /></ProtectedRoute>} />
            <Route path="/pratica"           element={<ProtectedRoute><Pratica /></ProtectedRoute>} />
            <Route path="/vocabulario"       element={<ProtectedRoute><Vocabulario /></ProtectedRoute>} />
            <Route path="/espaco-kids"       element={<ProtectedRoute><EspacoKids /></ProtectedRoute>} />
            <Route path="/jogo-pergunta"     element={<ProtectedRoute><JogoPergunta /></ProtectedRoute>} />
            <Route path="/color-game"        element={<ProtectedRoute><ColorGame /></ProtectedRoute>} />
            <Route path="/dicionario-faminto" element={<ProtectedRoute><DicionarioFaminto /></ProtectedRoute>} />
            <Route path="/pronunciacao"       element={<ProtectedRoute><JogoPronuncia /></ProtectedRoute>} />
            <Route path="/verbos"             element={<ProtectedRoute><Verbos /></ProtectedRoute>} />
            <Route path="/admin-verbos"       element={<ProtectedRoute adminOnly><AdminVerbos /></ProtectedRoute>} />
            <Route path="/phrasal-verbs"      element={<ProtectedRoute><PhrasalVerbs /></ProtectedRoute>} />
            <Route path="/falsos-cognatos"    element={<ProtectedRoute><FalsosCongnatos /></ProtectedRoute>} />
            <Route path="/idioms"             element={<ProtectedRoute><Idioms /></ProtectedRoute>} />
            <Route path="/conversa-ia"        element={<ProtectedRoute><ConversaIA /></ProtectedRoute>} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
        <FloatingCart />
      </Router>
    </AuthProvider>
  );
}
